import { useState, useEffect, useRef } from 'react'
import { API, API_ROUTER } from '../../../../../api'

export const useUserTeams = (id) => {
  const [teams, setTeams] = useState([])
  const [teamFilter, setTeamFilter] = useState('')
  const [requestSuccess, setRequestSuccess] = useState(false)
  const mountedRef = useRef(true)

  const getUserTeamsByRole = async (role = 'owner') => {
    if (id === undefined || !mountedRef.current) {
      return
    }

    setRequestSuccess(false)
    try {
      const res = await API.request({
        ...API_ROUTER.teams.getTeamByRole,
        pathKeys: {
          userId: id,
          role,
        },
      })
      if (mountedRef.current) {
        setTeams(res.teams)
        setRequestSuccess(true)
      }
    } catch (err) {
      console.log(err)
      if (mountedRef.current) {
        setRequestSuccess(true)
      }
    }
  }

  useEffect(() => {
    getUserTeamsByRole()

    return () => {
      mountedRef.current = false
    }
  }, [id])

  useEffect(() => {
    if (!id || !teamFilter || !mountedRef.current) {
      return
    }

    getUserTeamsByRole(teamFilter)
  }, [teamFilter, id])

  return {
    teams,
    teamFilter,
    setTeamFilter,
    requestSuccess,
    getUserTeamsByRole,
  }
}
